import axios from 'axios';
import { useAuthStore } from '../store/authStore';

// Honour VITE_API_URL if set at build time (split-domain deploys point this
// at https://api.kabbi.io/api). Falls back to a same-origin '/api' so dev
// (vite proxy) and single-domain prod still work without configuration.
const API_BASE = (import.meta.env.VITE_API_URL as string | undefined) || '/api';

const api = axios.create({ baseURL: API_BASE });

// Attach access token to every request
api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().accessToken;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// On 401: auto-refresh token once, then retry original request
let refreshing: Promise<void> | null = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      try {
        if (!refreshing) {
          refreshing = useAuthStore.getState().refresh().finally(() => {
            refreshing = null;
          });
        }
        await refreshing;
        const token = useAuthStore.getState().accessToken;
        original.headers.Authorization = `Bearer ${token}`;
        return api(original);
      } catch {
        useAuthStore.getState().logout();
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  },
);

export default api;
